import type { AgentRuntimeAttachedPullRequest } from "@cord/shared"

function normalizeOptionalString(value: unknown): string | null {
  if (typeof value !== "string") return null
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

export function normalizeAttachedPullRequest(
  value: unknown,
): AgentRuntimeAttachedPullRequest | undefined {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return undefined
  }

  const row = value as Record<string, unknown>
  if (typeof row.number !== "number" || !Number.isFinite(row.number)) {
    return undefined
  }

  return {
    number: Math.max(1, Math.floor(row.number)),
    url: normalizeOptionalString(row.url),
    title: normalizeOptionalString(row.title),
    branchName: normalizeOptionalString(row.branchName),
  }
}

export function sameAttachedPullRequest(
  left: AgentRuntimeAttachedPullRequest | undefined,
  right: AgentRuntimeAttachedPullRequest | undefined,
): boolean {
  if (left === right) return true
  if (!left || !right) return left === right
  return (
    left.number === right.number
    && left.url === right.url
    && left.title === right.title
    && left.branchName === right.branchName
  )
}
